

import React, { useState, useEffect , useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { TrendingUp, TrendingDown } from 'lucide-react';
import logo from './images/logo.jpeg';
import SearchComponent from './pages/search_stock.js'; 

// const StockTicker = () => {
//   const [data , setData] = useState([])
//   const [error, setError] = useState(null);
//   const refreshIntervalRef = useRef(null);


//   const fetch_notification = async () => {
//     try{
//       const response = await fetch(`https://whatsapp.finstrats.com/pullback_data_min`)
//       if(!response.ok){
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
//       const fetchedData = await response.json();
//       setData(fetchedData)
//     } catch(Error){
//       console.error("Error fetching stocks:", error);
//       setError("Failed to fetch stocks. Please try again later.");
//     }
//   };


//   useEffect(() => {
      
//       fetch_notification();
  
//       // Set up the interval for every 5 minutes (300000 milliseconds)
//       refreshIntervalRef.current = setInterval(() => {
//         fetch_notification();
//       }, 300000);
  
//       // Cleanup function to clear the interval when component unmounts
//       return () => {
//         if (refreshIntervalRef.current) {
//           clearInterval(refreshIntervalRef.current);
//         }
//       };
//     }, []); 
//   // const stockUpdates = [
//   //   { symbol: 'AARTI', price: 198.45, change: +2.5, message: 'New 52-week high!' },
//   //   { symbol: 'MARUTI', price: 245.67, change: -1.2, message: 'Volume spike detected' },
//   //   { symbol: 'INFY', price: 402.12, change: +1.8, message: 'Breaking resistance' },
//   //   { symbol: 'DMART', price: 142.89, change: +1.5, message: 'Crossing MA200' }
//   // ];

//   return (
//     <div className="ticker-container">
//           <div className="ticker-wrap">
//             <div className="ticker">
//               {data.map((stock, index) => (
//                 <div key={index} className="ticker-item">
//                   <span className="ticker-symbol">{stock.ticker_code}({stock.tick_num})</span>
//                   {/* <span className="ticker-price">{stock.price}</span> */}
//                   {/* <span className={`ticker-change ${stock['1D%'] >= 0 ? 'positive' : 'negative'}`}>
//                     {stock['1D%']  >= 0 ? (
//                       <TrendingUp size={16} style={{ marginRight: '4px' }} />
//                     ) : (
//                       <TrendingDown size={16} style={{ marginRight: '4px' }} />
//                     )}
//                     {Math.abs(stock['1D%'])}%
//                   </span> */}
                  
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//   );
// };

const Header = () => {
  const location = useLocation();
  const [activeHeader, setActiveHeader] = useState(null);
  const [activeSubheader, setActiveSubheader] = useState(null);
  

const callHeaderAPI = async () => {
    try {
    
      const response = await fetch('https://whatsapp.finstrats.com/intrvl_hl_data');
      
      console.log('Header API Response:', response.data);
      
      
    } catch (error) {
      console.error('Error calling Header API:', error);
      
    }
  };

  useEffect(() => {
    callHeaderAPI();
  }, []);

  const mainNavItems = [
    {
      name: 'Industry',
      to: '/',
      // subheader: [
      //   { name: 'Industry Overview', to: '/industry' },
      //   { name: 'Top Industry Gainers', to: '/gainers_losers_ind' },
      // ],
    },
    {
      name: 'Stocks',
      to: '/stocks',
      // subheader: [
      //   { name: 'Top Gainers Losers', to: '/gainers_losers' },
      //   { name: 'watchlist', to: '/watchlist' },
        
      // ],
    },
    {
      name: 'F&O',
      to: '/f_o',
      // subheader: [
      //   { name: 'F&O Stocks', to: '/' },
      //   { name: 'Strategy', to: '/f_o_watchlist' },
      //   { name: 'Pullback', to: '/pullback' },
      //   { name: 'Stock Details', to: '/f_o_listdata' },
      //   { name: 'Industry', to: '/f_o_industry_score' },
      //   { name: 'Index', to: '/index' },
      //   { name: 'Blast', to: '/highvolume' },
        
      // ],
    },
    {
      name: 'Strategies',
      to: '/strategy',
      // subheader: [
      //   { name: 'Result Impact', to: '/strategies_res' },
      //   { name: 'Stock Duration', to: '/strategies_duration' },
        
      // ],
    },
    {
      name: 'Stage',
      to: '/stage',
    },
    {
      name: 'Market',
      to: '/market',
    },
    {
      name: 'Insider',
      to: '/insider',
    },
  ];

 
  // Update active states based on current route
  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath === '/') {
      setActiveHeader(null);
      setActiveSubheader(null);
      return;
    }

    // Find the header and subheader that match the current path
    for (const item of mainNavItems) {
      if (item.subheader) {
        const matchingSubheader = item.subheader.find(sub => sub.to === currentPath);
        if (matchingSubheader) {
          setActiveHeader(item.name);
          setActiveSubheader(matchingSubheader.name);
          return;
        }
      }
      // Check main header path
      if (item.to === currentPath) {
        setActiveHeader(item.name);
        setActiveSubheader(null);
        return;
      }
    }
  }, [location.pathname]);

  const ScreenerIcon = ({ url }) => (
        <svg
          onClick={() => window.open(url, "_blank")}
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            cursor: "pointer",
            
            color: "#6c757d",
            transition: "color 0.3s ease",
          }}
        >
          <path d="M15 3h6v6" />
          <path d="M10 14 21 3" />
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        </svg>
      );
  const handleHeaderClick = (event, headerName, hasSubheader) => {
    if (hasSubheader) {
      event.preventDefault();
      setActiveHeader(headerName === activeHeader ? null : headerName);
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link
          to="/card"
          className="logo-link"
          onClick={() => {
            setActiveHeader(null);
            setActiveSubheader(null);
          }}
        >
          <img src={logo} alt="Logo" className="header-logo" />
        </Link>

        <nav className="main-nav">
          <ul className="nav-list">
            {mainNavItems.map((item) => (
              <li
                key={item.name}
                className={`nav-item ${activeHeader === item.name ? 'active' : ''}`}
              >
                <Link
                  to={item.to}
                  className={`nav-link ${activeHeader === item.name ? 'active' : ''}`}
                  onClick={(e) => handleHeaderClick(e, item.name, !!item.subheader)}
                >
                  {item.name}
                  <span className="link-underline"></span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>


        <div className="header-search">
          <SearchComponent />
        </div>

         <div className="screener-link">
                    <ScreenerIcon url={"https://live.finstrats.com/"} />
                  </div>
       
      </div>

      {activeHeader && (
        <div className="subheader-container">
          <ul className="subheader-list">
            {mainNavItems
              .find((item) => item.name === activeHeader)
              ?.subheader?.map((subItem) => (
                <li key={subItem.name} className="subheader-item">
                  <Link
                    to={subItem.to}
                    className={`subheader-link ${
                      activeSubheader === subItem.name ? 'active' : ''
                    }`}
                  >
                    {subItem.name}
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
